import React from 'react';
import moment from 'moment';

import DateFormat from 'constants/date_format';

const FormattedDate = ({ children, omitCurrentYear, className }) => {
  const date = moment(children);
  let formattedDate = date.format(DateFormat.MONTH_DAY_SHORT);
  if (omitCurrentYear && !date.isSame(Date.now(), 'year')) {
    formattedDate = date.format(DateFormat.MONTH_DAY_YEAR_SHORT);
  }

  return (
    <time
      className={className}
      dateTime={date.toJSON()}
      title={date.format(DateFormat.LONG)} // This shows the date on hover of this element
    >
      {formattedDate}
    </time>
  );
};

FormattedDate.defaultProps = {
  omitCurrentYear: true,
  className: null,
};

export default FormattedDate;
